<!-- 各保险公司理赔失效对比(天) -->
<template>
	<div :id="id" class="o-echarts"></div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts';
import moment from 'moment';
let SettlementContrastagingChart = null;
export default {
	name: 'SettlementContrastagingChart',
	props: {
		id: {
			type: String,
			required: false,
			default: 'SettlementContrastagingChart'
		},
		subtext: {
			type: String,
			required: false,
			default: moment().format('YYYY年MM月DD日')
		}
	},
	data() {
		return {
			//  id: 'SettlementContrastagingChart',//地图渲染容器id
			option: {
				title: {
					text: '',
					subtext: '（2020年4月26日）',
					left: 'right'
				},
				tooltip: {
					trigger: 'axis'
				},
				dataset: {
					// dimensions: ['headCompanyName', '平均完成时间', '平均查勘时间', '平均定损时间'],
					// source: [
					// 	{ headCompanyName: '永安保险', 平均完成时间: 1,  平均查勘时间: 5,平均定损时间: 6, },
					// 	{ headCompanyName: '华安保险', 平均完成时间: 2,  平均查勘时间: 6,平均定损时间: 3, },
					// 	{ headCompanyName: '大众保险', 平均完成时间: 4,  平均查勘时间: 7,平均定损时间: 8,   },
					// 	{ headCompanyName: '人民保险', 平均完成时间: 3,  平均查勘时间: 5,平均定损时间: 8, },
					// 	{ headCompanyName: '天安保险', 平均完成时间: 4,  平均查勘时间: 7,平均定损时间: 4,  },
					// 	{ headCompanyName: '人寿保险', 平均完成时间: 9,  平均查勘时间: 5,平均定损时间: 1,   },
					// 	{ headCompanyName: '阳光保险', 平均完成时间: 4,  平均查勘时间: 8,平均定损时间: 5,  },
					// 	{ headCompanyName: '太平洋保险',平均完成时间: 3,  平均查勘时间: 9,平均定损时间: 9,   },
					// 	{ headCompanyName: '华泰保险', 平均完成时间: 7,  平均查勘时间: 5,平均定损时间: 8,   },
					// 	{ headCompanyName: '东方保险', 平均完成时间: 5,  平均查勘时间: 5,平均定损时间: 8,  },
					// ]
				},
				legend: {
					top: 10,
					// left:20,
					itemGap: 10,
					itemWidth: 10,
					itemHeight: 10,
					textStyle: {
						color: '#333'
					},
					icon: 'rect'
					// data: ["水稻政策性保险", "玉米政策性保险", "大豆政策性保险", "确权面积"]
				},
				grid: {
					left:50,
					right: 50
				},
				toolbox: {
					show: true
				},
				calculable: true,
				xAxis: [
					{
						type: 'category',
						//data: ['永安保险', '华安保险', '大众保险', '人民保险', '天安保险', '人寿保险', '阳光保险', '太平洋保险', '华泰保险', '东方保险'],

						axisTick: {
							show: false
						},
						axisLine: {
							lineStyle: {
								color: '#aaa',
								type: 'dotted'
							}
						},
						axisLabel: {
							color: '#333',
							interval:0,
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						axisTick: {
							show: false
						},
						splitLine: {
							lineStyle: {
								type: 'dotted'
							}
						},
						axisLine: {
							show: false
						}
						// axisLabel: {
						//   formatter (val) {
						//     if (val >= 10000) {
						//       return val / 10000 + "万";
						//     } else return val;
						//   }
						// }
					}
				],
				color: ['#1a8dee', '#ff9023','#00d5b2'],
				series: [
					{
						name: '',
						//data: [4, 6, 3,6,8,2,1,8,5,7],
						type: 'bar',
						barWidth: 14
					},
					{
						name: '',
						//data: [4, 4, 5,5,1,8,9,3,4,7],
						type: 'bar',
						// stack: "政策性保险",
						barWidth: 14
					},
					{
						name: '',
						//data: [6, 5, 2,6,8,8,3,5,6,9],
						type: 'bar',
						// stack: "政策性保险",
						barWidth: 14
					},
					
				]
			}
		};
	},
	mounted() {
		// this.initMap()
	},
	watch: {},
	methods: {
		listenResize() {
			//窗口改变大小
			if (SettlementContrastagingChart) {
				SettlementContrastagingChart.resize();
			}
		},

		initMap(optionData) {
			//设置时间
			//this.option.title.subtext = this.subtext || '';
			this.option.title.subtext = optionData.date+'年' || '';
			// this.option.legend.data = optionData.legend
			// this.option.color = optionData.color
			// this.option.xAxis.data = optionData.xAxis
			// this.option.series = optionData.series
			this.option.dataset = optionData.dataset || [];
			SettlementContrastagingChart = echarts.init(document.getElementById(this.id));
			SettlementContrastagingChart.setOption(this.option);
		}
	},

	components: {}
};
</script>

<style scoped lang="less">
.o-echarts {
	min-width: 30px;
	min-height: 30px;
	width: 100%;
	height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/SettlementContrastagingChart.vue